import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Customer } from '../pages/Projects';
import { Alert, IconButton, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { addCustomer } from '../firebase';

interface Props {
  editingCustomer?: Customer;
  open: boolean;
  setOpen: (show: boolean) => void;
  updateCustomerCallback: (customer: Customer) => void;
  addCustomerCallback: (customer: Customer) => void;
  customers: Customer[]
}

export default function CreateEditCustomerDialog(props: Props) {
  const { editingCustomer, open, setOpen, updateCustomerCallback, addCustomerCallback, customers } = props;

  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');

  useEffect(() => {
    setName(props.editingCustomer?.name ?? '');
    setSlug(props.editingCustomer?.slug ?? '');
  }, [props.editingCustomer?.name, props.editingCustomer?.slug])

  const handleClose = () => {
    setOpen(false);
  };

  const isDuplicateSlug = () => {
    if (!slug.trim()) return false;
    return customers.some((customer) =>
      customer.id !== editingCustomer?.id &&
      customer.slug.trim().toLowerCase() === slug.trim().toLowerCase()
    );
  }

  const validate = () => {
    if (isDuplicateSlug()) return true;

    if (editingCustomer) {
      if (
        name !== props.editingCustomer?.name ||
        slug !== props.editingCustomer?.slug
      ) return false
      return true;
    } else {
      if (name && slug) return false
      return true
    }
  }

  const save = () => {
    if (!props.editingCustomer?.id) return;

    const newCustomer = {
      id: props.editingCustomer?.id,
      name,
      slug,
    } as Customer

    updateCustomerCallback(newCustomer);
  }

  const addCustomerHandler = () => {
    const newCustomer = {
      name,
      slug,
    } as Customer;

    addCustomer(newCustomer).then((id: string) => {
      addCustomerCallback(
        {
          id,
          ...newCustomer
        }
      )
    })
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 4 } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {editingCustomer ? 'Opdater kunde' : 'Opret kunde'}
        <IconButton onClick={handleClose} size="small"><CloseIcon fontSize="small" /></IconButton>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <TextField
            autoFocus
            required
            margin="dense"
            id="customer-name"
            name="customer-name"
            label="Navn"
            type="text"
            fullWidth
            onChange={(e) => setName(e.target.value)}
            value={name}
          />
          <TextField
            required
            margin="dense"
            id="customer-slug"
            name="customer-slug"
            label="Slug"
            type="text"
            fullWidth
            onChange={(e) => setSlug(e.target.value)}
            value={slug}
          />
          {isDuplicateSlug() && <Alert severity="error">Denne slug er allerede i brug.</Alert>}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} color="inherit">Annuller</Button>
        <Button variant="contained" onClick={editingCustomer ? save : addCustomerHandler} disabled={validate()} type="submit">{editingCustomer ? 'Opdater' : 'Opret'}</Button>
      </DialogActions>
    </Dialog>
  );
}
